export default __webpack_public_path__ + "static/media/Groupeu476.84079c04.svg";